function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M158 77V422H448V77H158ZM427 399H180V100H427V399Z",
  className: "secondary-lightened-1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M79.17 200.27L98.9 240.25L143.02 246.66L111.1 277.78L118.63 321.72L79.17 300.98L39.71 321.72L47.24 277.78L15.32 246.66L59.44 240.25L79.17 200.27Z",
  className: "primary-lightened-2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.63 321.72L79.17 300.98L111.1 277.78L118.63 321.72Z",
  className: "primary"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.24 277.78L59.44 240.25L15.32 246.66L47.24 277.78Z",
  className: "primary-lightened-1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M412.5 166V250",
  className: "secondary-stroke",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M412.5 251V344",
  className: "secondary-stroke",
  strokeWidth: 5,
  strokeMiterlimit: 10
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M194.5 289V114.5H412.5V158",
  className: "secondary-stroke",
  strokeWidth: 5,
  strokeMiterlimit: 10
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M194.5 351V287",
  className: "secondary-stroke",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M392.84 343.86C391.32 341.86 389.71 339.99 388.04 338.14C381.571 331.113 373.705 325.513 364.947 321.701C356.189 317.888 346.732 315.947 337.18 316H271.57C261.766 315.965 252.067 318.022 243.121 322.033C234.174 326.044 226.186 331.917 219.69 339.26C207.418 353.233 199.432 370.446 196.69 388.84V389H412.19C409.719 372.543 403.055 356.998 392.84 343.86Z",
  className: "primary"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M306 168L307 168.55V287.45C294.76 294.09 281.75 296.84 267.34 293.71C258.787 291.901 250.855 287.889 244.33 282.071C237.805 276.253 232.913 268.831 230.14 260.54C223.45 240.03 229.23 220.45 241.73 207.41C241.73 206.65 241.67 205.88 241.67 205.1C241.681 197.577 243.671 190.189 247.439 183.677C251.207 177.166 256.621 171.76 263.138 168.001C269.655 164.243 277.045 162.264 284.569 162.264C292.092 162.264 299.483 164.242 306 168Z",
  className: "primary-lightened-1"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.69 243.23C384.69 252.42 382.244 261.443 377.603 269.375C372.962 277.306 366.293 283.86 358.282 288.362C350.271 292.864 341.206 295.152 332.017 294.992C322.829 294.831 313.849 292.228 306 287.45V168C312.52 164.235 319.916 162.252 327.445 162.251C334.975 162.25 342.371 164.231 348.892 167.995C355.413 171.76 360.828 177.174 364.593 183.694C368.358 190.214 370.34 197.611 370.34 205.14C370.34 205.92 370.32 206.69 370.28 207.45C379.531 217.064 384.696 229.888 384.69 243.23Z",
  className: "primary"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M351.06 245H347V226H352C352.899 226 353.787 226.192 354.605 226.565C355.423 226.938 356.151 227.483 356.74 228.162C357.329 228.841 357.765 229.639 358.019 230.501C358.272 231.363 358.338 232.27 358.21 233.16L357.29 239.61C357.075 241.108 356.327 242.479 355.182 243.469C354.038 244.46 352.574 245.003 351.06 245V245Z",
  className: "primary-lightened-2"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M260.94 245H265V226H260C259.101 226 258.213 226.192 257.395 226.565C256.577 226.938 255.849 227.483 255.26 228.162C254.671 228.841 254.235 229.639 253.981 230.501C253.728 231.363 253.662 232.27 253.79 233.16L254.71 239.61C254.924 241.108 255.673 242.479 256.818 243.469C257.962 244.46 259.426 245.003 260.94 245V245Z",
  className: "primary-lightened-2"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M306.09 201.81C293.74 215.32 276.81 223.81 261.01 226.15C261.06 226.58 263.23 254.32 263.23 254.32C264.47 268.09 273.23 283.51 284.4 291.55C292.52 297.38 299.4 299.9 306.09 299.98C312.75 299.9 319.66 297.38 327.78 291.55C338.98 283.55 347.71 268.09 348.95 254.32C348.95 254.32 351.12 226.58 351.16 226.15C335.37 223.85 318.44 215.32 306.09 201.81Z",
  className: "primary-lightened-2"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M267.76 316L304 368.97L341.07 316H267.76Z",
  className: "primary-lightened-2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80 194V116H147",
  className: "secondary-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M461 379H524V296",
  className: "secondary-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158 422L180 399H427L448 422H158Z",
  className: "secondary"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158 77L180 100H427L448 77H158Z",
  className: "secondary-lightened-2"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M475 287H505L475 317V287Z",
  className: "primary"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M476.67 208V287.95L584 288V208H476.67Z",
  className: "primary-lightened-1"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M584 208L504 288H475V208H584Z",
  className: "primary-lightened-2"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

export default __webpack_public_path__ + "static/media/add_profile_pic.09d65c9d.svg";
export { SvgComponent as ReactComponent };